<ion-grid>
  <ion-row>
    <ion-col size="12" class="ion-text-center container-enode">
      <p>
        Bli med på testing av ny funksjonalitet og hjelp oss med å lage den
        beste smartladingsløsningen.
      </p>

      <img src="assets/img/enode/enode-charging.svg" />

      <p>
        Vi samarbeider med Enode for å tilby smartlading. Du kan lære mer om
        hvordan det fungerer og hvilke biler som støttes
        <a target="_blank" href="https://www.ishavskraft.no/privat/smartlading"
          ><strong>her</strong> <ion-icon name="open-outline" size="small"></ion-icon></a
        >.
      </p>
      @if (isLoading) {
        <ion-spinner name="crescent"></ion-spinner>
      }
      <ion-button class="dark link-button" (click)="linkVehicle()">
        Kom i gang med smartlading
      </ion-button>
    </ion-col>
    <ion-col>
      <h2 class="mb-4 ion-text-center">Greit å vite før du fortsetter</h2>
      <ion-accordion-group class="lg:max-w-lg max-w-full m-auto">
        <ion-accordion value="Hva er smartlading">
          <ion-item slot="header">
            <ion-label>
              <strong>
                Hva er smartlading?
              </strong>
            </ion-label>
          </ion-item>
          <div slot="content" >
            <p class="px-3">
              Når du kobler til laderen vil vi hensynta mengde strøm laderen leverer, og kommende nettleie- og strømpriser.
              Strømstøtte blir også medregnet der det er aktuelt. 
              Ser vi dette i sammenheng med fristen du har satt, så finner vi den rimeligste perioden for når din bil skal lade.
            </p>
          </div>
        </ion-accordion>
        <ion-accordion value="Feil">
          <ion-item slot="header">
            <ion-label>
              <strong>
                Vanligste feil
              </strong>
            </ion-label>
          </ion-item>
          <div slot="content">
            <ol>
              <li>
                <p>
                  Hvis du har aktivert tidsplaner eller annen smart ladefunksjonalitet via laderen, kjøretøyet eller andre apper, vil disse skape problemer for smartladingen.
                </p>
              </li>
              <li>
                <p>
                  Hvis du har lastbalansering på laderen din eller har en enhet koblet til HAN-porten, vil dette skape problemer for smartladingen.
                </p>
              </li>
              <li>
                <p>
                  Om du har en lader som må aktiveres med brikke eller app, vil dette skape problemer for smartladingen.
                </p>
              </li>
            </ol>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <p class="ion-text-center">
        Om du har spørsmål, ta kontakt med oss på
        <a href="mailto:kunde@ishavskraft.no">
          <strong>
            kunde&#64;ishavskraft.no
          </strong>
        </a>
        eller ring oss på 
        <a href="tel:776 12 000">
          <strong>
            776 12 000
          </strong>
        </a>
      </p>
    </ion-col>
  </ion-row>
</ion-grid>
